// extracted by mini-css-extract-plugin
export default {"page":"v5M6QkDT","wrapper":"CFiXT97M","main":"rKsZ4va2","title":"U0lgLBzx","conditionsWrapper":"QYjcJ63E","cardsWrapper":"KDaKHstr","selector":"CMAWS0_f","backToGameButton":"WYzkrVa6"};
    if(module.hot) {
      // 1721069998945
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  